import * as angular from 'angular';

// Simplified Backbone extend method for prototypal inheritance
export function extend(protoProps, staticProps) {
  // eslint-disable-next-line @typescript-eslint/no-this-alias
  const parent: any = this;
  let child;

  if (protoProps && typeof protoProps.$constructor === 'function') {
    child = protoProps.$constructor;
  } else {
    child = function () {
      // eslint-disable-next-line prefer-rest-params
      return parent.apply(this, arguments);
    };
  }

  // Add static properties to the constructor function, if supplied.
  angular.extend(child, parent, staticProps);

  // Set the prototype chain to inherit from `parent`, without calling
  // `parent`'s constructor function.
  const Surrogate = function () {
    this.$constructor = child;
  };
  Surrogate.prototype = parent.prototype;
  child.prototype = new Surrogate();

  // Add prototype properties (instance properties) to the subclass,
  // if supplied.
  if (protoProps) {
    angular.extend(child.prototype, protoProps);
  }

  // Set a convenience property in case the parent's prototype is needed
  // later.
  child.__super__ = parent.prototype;

  return child;
}
